var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('v-btn',{attrs:{"icon":"","href":_vm.url}},[_c('v-icon',{attrs:{"color":"info"}},[_vm._v(" mdi-information ")])],1),_c('v-card-title',{staticClass:"text-h5 pl-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }